<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-btn text>
          <a :href="`${path}sns/samples/user_upload_sample.xlsx`" download>Download sample file</a>
        </v-btn>
        <v-card-title>
          <!-- <backbutton></backbutton> -->
          Upload Users Data
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col v-if="crude_users.length == 0">
              <input type="file" id="file" name="users" ref="file" accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" multiple
                @change="handleFileUpload" />
            </v-col>
            <v-col v-else>
              <v-btn color="success" :loading="isProcessing" :disabled="isProcessing" @click="processFile">
                Upload file</v-btn>

              &nbsp;
              <v-btn color="error" @click="truncatePendingDocuments">
                Delete</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <span style="color: red" v-show="isError">{{ error_msg }} </span>
          </v-row>
        </v-card-text>
      </v-card>
      <br />
      <v-card elevation="6">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Email</th>
                <th class="text-left">Age</th>
                <th class="text-left">Rank</th>
                <th class="text-left">Date of Joining</th>
                <th class="text-left">Contract Expiry</th>
                <th class="text-left">On-board Since</th>
                <th class="text-left">Vessel</th>
                <th class="text-left">Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cruduser, at) in crude_users" :key="`cruduser${at}`">
                <td>{{ cruduser.name }}</td>
                <td>{{ cruduser.email }}</td>
                <td>{{ cruduser.age }}</td>
                <td>{{ cruduser.rank }}</td>
                <td>{{ cruduser.date_of_joining }}</td>
                <td>{{ cruduser.contract_expiry }}</td>
                <td>{{ cruduser.on_board_since }}</td>
                <td>{{ cruduser.vessel_name }}</td>
                <td>{{ cruduser.remarks }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
      <!-- Upload Success Dialog Box -->
      <v-dialog v-model="is_Uploaded" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: green; font-size: 90px; width: 200px !important">
                  mdi-cloud-upload-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been uploaded successfully. Now you can
                        Preview the List & process accordingly.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Uploaded = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Process Success Dialog Box -->
      <v-dialog v-model="is_Processed" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: green; font-size: 90px; width: 200px !important">
                  mdi-progress-download
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>
                        The file has been processed successfully. Now you can
                        see your users in User's Tab.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Processed = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Truncate Success Dialog Box -->
      <v-dialog v-model="is_Truncated" width="600">
        <v-card>
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: red; font-size: 90px; width: 200px !important">
                  mdi-delete-empty-outline
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Deleted!</h1>
                      <br />
                      <h3>
                        The file has been deleted successfully. Now you can
                        select a new file to upload.
                      </h3>
                      <br />
                      <v-btn color="success" @click="is_Truncated = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
// import backbutton from "@/components/backbutton.vue";
export default {
  //   components: { backbutton },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Upload User Excel",
  },
  data() {
    return {
      crude_users: [],
      isLoading: false,
      is_mail_sent: false,
      isUploading: false,
      is_Uploaded: false,
      isProcessing: false,
      is_Processed: false,
      is_Truncated: false,
      isError: false,
      error_msg: "",
      path: "",
    };
  },
  mounted() {
    this.getData();
    this.path = this.mediaUrl;
    console.log(this.path);
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let crude_users = await axios.get(`/crude_users`);
      this.crude_users = crude_users.data.data;
      this.count = crude_users.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async handleFileUpload(event) {
      this.isUploading = true;
      this.isUploadingError = false;
      this.error_msg = "";
      
      // Check if files were selected
      if (!event.target.files || event.target.files.length === 0) {
        this.isError = true;
        this.error_msg = "Please select a file to upload.";
        this.isUploading = false;
        return;
      }
      
      const file = event.target.files[0];
      console.log('Selected file:', file);
      
      let formData = new FormData();
      formData.append("users", file); // Make sure the field name matches backend expectation
      this.changeValue = 100;
      
      try {
        console.log('Sending upload request...');
        const response = await axios.post("upload_user", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        console.log('Upload response:', response);
        
        if (response.data.success) {
          this.crude_users = response.data.data || [];
          this.is_Uploaded = true;
          console.log(`Successfully uploaded ${this.crude_users.length} records`);
        } else {
          this.isError = true;
          this.error_msg = response.data.message || "Failed to upload file. Please try again.";
        }
      } catch (error) {
        console.error("Upload error:", error);
        console.error("Error response:", error.response);
        this.isError = true;
        if (error.response && error.response.data && error.response.data.message) {
          this.error_msg = error.response.data.message;
        } else {
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        }
      } finally {
        this.isUploading = false;
      }
    },
    async processFile() {
      try {
        this.isProcessing = true;
        const response = await axios.get(`process_user`);
        
        if (response.data.success) {
          // Show success message
          this.is_Processed = true;
          // Refresh the data to show empty table
          this.crude_users = [];
        } else {
          this.isError = true;
          this.error_msg = response.data.message || "Failed to process file. Please try again.";
        }
      } catch (error) {
        console.error("Process error:", error);
        this.isError = true;
        if (error.response && error.response.data && error.response.data.message) {
          this.error_msg = error.response.data.message;
        } else {
          this.error_msg =
            "Looks like system faced an error while processing the File. Kindly check the file before processing ...";
        }
      } finally {
        this.isProcessing = false;
      }
    },
    async truncatePendingDocuments() {
      try {
        const response = await axios.get("truncate_users");
        
        if (response.data.success) {
          this.is_Truncated = true;
          this.crude_users = [];
        } else {
          this.isError = true;
          this.error_msg = response.data.message || "Failed to truncate data.";
        }
      } catch (error) {
        console.error("Truncate error:", error);
        this.isError = true;
        if (error.response && error.response.data && error.response.data.message) {
          this.error_msg = error.response.data.message;
        } else {
          this.error_msg = "Failed to truncate data. Please try again.";
        }
      }
    },
  },
};
</script>
<style scoped>
.v-data-table>.v-data-table__wrapper>table>thead>tr>th,
td {
  min-width: 130px !important;
}
</style>
